<template>
  <div class="pa-4">
    <portal to="app-header">
      <router-link
        to="/tableheadingsticky"
        class="ml-2"
      >
        看看示例
      </router-link>
    </portal>
    <CodeHighlight :code="code" />
  </div>
</template>

<script>
import CodeHighlight from '@/modules/codehl/CodeHighlight.vue';

export default {
  components: {
    CodeHighlight,
  },
  data() {
    return {
      code: `
<style scoped>
::v-deep thead.v-data-table-header {
  position: sticky;
  top: 0;
  /* 隐藏行选择checkbox */
  z-index: 9999;
}
/* 亮色模式 */
::v-deep .theme--light .v-data-table-header {
  background-color: rgb(253, 253, 253);
}
/* 暗色模式 */
::v-deep .theme--dark .v-data-table-header {
  background-color: rgb(50, 50, 50);
}
</style>
`,
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped>
.v-btn {
  margin-right: 10px;
}
</style>